var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-landing",
        "dialog-class": "base-modal",
        "body-class": "p-0",
        "hide-header": "",
        "hide-header-close": "",
        "hide-footer": "",
        centered: "",
      },
      on: { hidden: _vm.changeLandingModal },
    },
    [
      _c("div", { attrs: { id: "event-landing" } }, [
        _c("img", {
          staticClass: "notice-landing",
          attrs: {
            src: `${_vm.$s3}/img/${_vm.lang}/event/landing/new/notice.webp?${_vm.$ver}`,
            alt: "",
          },
          on: { click: _vm.goToLandingPage },
        }),
        _c(
          "button",
          {
            staticClass: "close",
            on: {
              "~click": function ($event) {
                return _vm.hideModal()
              },
            },
          },
          [
            _c("img", {
              staticClass: "close-btn",
              attrs: {
                src: `${_vm.$s3}/img/common/event/landing/new/close.webp?${_vm.$ver}`,
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }